import { DataFieldType } from "@iventis/domain-model/model/dataFieldType";
import { MapLayer } from "@iventis/domain-model/model/mapLayer";
import { AnySupportedGeometry, LocalGeoJson, MapObjectProperties } from "@iventis/map-types";
import { createMapFromArray } from "@iventis/utilities";
import { Feature } from "@turf/helpers";

/**
 * Gets the datafields to display on the map object tooltip, show in order of the datafield order accept, if map object name then show it at the top
 */
export function getDataFieldsToDisplayOnMapObjectTooltip(layer: MapLayer, mapObjectNameDataFieldId: string) {
    const layerDataFieldsMap = createMapFromArray(layer.dataFields, "id");

    // If no datafields are selected to be shown, then show the map object name datafield
    if (layer.tooltipDataFieldIds == null || layer.tooltipDataFieldIds.length === 0) {
        const mapObjectNameDataField = layerDataFieldsMap.get(mapObjectNameDataFieldId);
        if (mapObjectNameDataField == null) {
            return { layerName: layer.name, dataFieldsToDisplay: [] };
        }
        return { layerName: layer.name, dataFieldsToDisplay: [{ id: mapObjectNameDataField.id, type: mapObjectNameDataField.type, name: mapObjectNameDataField.name, order: -1 }] };
    }

    const dataFieldsToDisplay: { id: string; type: DataFieldType; name: string; order: number }[] = [];
    layer.tooltipDataFieldIds.forEach((dataFieldId) => {
        const dataField = layerDataFieldsMap.get(dataFieldId);
        if (dataField == null) {
            return;
        }
        // If map object name datafield is selected to be shown, then show at the top
        const order = mapObjectNameDataFieldId === dataField.id ? -1 : dataField.order;
        dataFieldsToDisplay.push({ id: dataField.id, type: dataField.type, name: dataField.name, order });
    });
    return { layerName: layer.name, dataFieldsToDisplay: dataFieldsToDisplay.sort((a, b) => a.order - b.order) };
}

/**
 * Gets the map object properties to display on the map object tooltip, tries to find the map object stored inside the geoJSON (from map slice) as it has most up-to-date data
 */
export function getMapObjectPropertiesToDisplayOnMapObjectTooltip(mapObject: Feature<AnySupportedGeometry, MapObjectProperties>, geoJSON: LocalGeoJson) {
    // Get the local map objects for the layer
    const layerMapObjects = geoJSON[mapObject.properties.layerid];
    if (layerMapObjects == null) {
        return mapObject.properties;
    }
    const { baseMapObjectId, id } = mapObject.properties;
    // Search for the local map object
    const foundMapObject = layerMapObjects.find(({ objectId }) => objectId === (baseMapObjectId ?? id));
    // If the local map object can't be found return the original map object
    return foundMapObject ? foundMapObject.feature.properties : mapObject.properties;
}
